import { render, staticRenderFns } from "./agpFooter.vue?vue&type=template&id=7274e477&scoped=true&"
import script from "./agpFooter.vue?vue&type=script&lang=js&"
export * from "./agpFooter.vue?vue&type=script&lang=js&"
import style0 from "./agpFooter.vue?vue&type=style&index=0&id=7274e477&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7274e477",
  null
  
)

export default component.exports